import {useEffect, useState} from "react";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import {TableWithStripedRows} from "../../../components/elements/Tables/TableComponent";

export function ListBranchOffices(props) {
  const [didMount, setDidMount] = useState(false);
  const {list, filterById} = props;

  useEffect(() => {
    setDidMount(true);
  }, []);
  
  useEffect(() => {
    if(didMount){
      list();
    }
  }, [didMount, list]);


  const columnsName = [
    {
      selector: row => row.id,
      name: 'Id',
    },
    {
      selector: row => row.name,
      name: 'Nombre',
    },
    {
      selector: row => row.department.name,
      name: 'Departamento',
    },
    {
      selector: row => row.municipality.name,
      name: 'Municipio',
    },

  ]

  const Filters = [
    {
      placeholder: 'Departamento',
      name_filter: 'department_id',
      urlOptionList: 'department/select_option'
    },
    {
      placeholder: 'Municipio',
      name_filter: 'municipality_id',
      dependence: filterById?.department_id ?? 0,
      urlOptionList: 'municipality/select_option'
    },
  ]

  return (
    <ContainerComponent
      uri={'crear'}
      title="Sucursal"
      textBtnCreate={'Crear Sucursal'}
    >
      <TableWithStripedRows
        {...props}
        filters={Filters}
        titleExcel="Sucursal"
        changeFilter={props.changeFilterById}
        columns={columnsName}
        actionDelete={props.deleteRecord}
        searchChange={props.searchChange}
        searchValue={props.search}
      />
    </ContainerComponent>
  )
}